"use client";

import { c as _c } from "react/compiler-runtime";
import { useProfileDetailsSheetStore } from "@/store/profileDetailsSheetStore";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";

// `trackingProps` (contractor id/name) is optional: only callers that pass it report the tap.
export default function ProfileStatButton(t0) {
  const $ = _c(8);
  const {
    highlightKey,
    children,
    trackingProps
  } = t0;
  const open = useProfileDetailsSheetStore(_temp);
  const track = useInhomzTrack();
  let t1;
  if ($[0] !== highlightKey || $[1] !== open || $[2] !== track || $[3] !== trackingProps) {
    t1 = () => {
      if (trackingProps) {
        track(inhomzEvents.contractorProfile.VIEW_MORE_CLICKED, {
          ...trackingProps,
          placement: "stat",
          event_value: highlightKey
        });
      }
      open(highlightKey);
    };
    $[0] = highlightKey;
    $[1] = open;
    $[2] = track;
    $[3] = trackingProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== t1) {
    t2 = <button type="button" onClick={t1} className="flex flex-1 flex-col gap-1 min-w-0 text-left">{children}</button>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(s) {
  return s.open;
}